import { render } from "./Edit.vue?vue&type=template&id=4d45de8d&scoped=true"
import script from "./Edit.vue?vue&type=script&lang=ts"
export * from "./Edit.vue?vue&type=script&lang=ts"

import "./Edit.vue?vue&type=style&index=0&id=4d45de8d&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-4d45de8d"

export default script